module.exports = __webpack_public_path__ + "static/logo-nygc-e5120a15db522f6e8e04fe56a058754e.png";